import styled from "styled-components";
import LocationIcon from "@public/assets/icon/location-icon.svg";
import PhoneIcon from "@public/assets/icon/phone.svg";
import MailIcon from "@public/assets/icon/email.svg";
import {SIZES} from "@/components/constants";
import FormWrap from "@/app/[locale]/help-center/components/FormWrap";

const ContactWrap = ({langData}) => {
    return(
        <ContactArea>
            <ContactWrapper>
                <div className={"info-title"}>
                    <h2 dangerouslySetInnerHTML={{__html: langData["contact-text"]}}/>
                    <p dangerouslySetInnerHTML={{__html: langData["contact-comment"]}}/>
                </div>
                <div className={"info-desc"}>
                    <h5 dangerouslySetInnerHTML={{__html: langData["contact-info-text"]}}/>
                    <ul>
                        <li>
                            <div className={"img-wrap"}>
                                <img src={LocationIcon?.src} alt={"위치 아이콘"}/>
                            </div>
                            <p dangerouslySetInnerHTML={{__html: langData["contact-info-address"]}}/>
                        </li>
                        <li>
                            <div className={"img-wrap"}>
                                <img src={PhoneIcon?.src} alt={"전화 아이콘"}/>
                            </div>
                            <p dangerouslySetInnerHTML={{__html: langData["contact-info-tel"]}}/>
                        </li>
                        <li>
                            <div className={"img-wrap"}>
                                <img src={MailIcon?.src} alt={"메일 아이콘"}/>
                            </div>
                            <p dangerouslySetInnerHTML={{__html: langData["contact-info-email"]}}/>
                        </li>
                    </ul>
                </div>
            </ContactWrapper>
            <FormWrap langData={langData}/>
        </ContactArea>
    )
}


const ContactArea = styled.div`
    row-gap: 40px;
    justify-content: space-between;
    align-items: stretch;
    flex-direction: column;
    display: flex;
    @media (min-width: ${SIZES.MOBILE_L}) {
        flex-direction: row;
    }
`

const ContactWrapper = styled.div`
    column-gap: 16px;
    justify-content: space-between;
    flex-direction: column;
    display: flex;

    .info-title {
        display: flex;
        flex-direction: column;
        gap: 16px;

        h2 {
            font-size: 32px;
            font-weight: 700;
            color: #07903a;
        }

        p {
            max-width: 370px;
            font-size: 18px;
            line-height: 28px;
            font-weight: 500;
        }
    }

    .info-desc {
        color: #6a6a6a;
        gap: 8px;
        flex-direction: column;
        display: flex;

        h5 {
            font-weight: 500;
            font-size: 18px;
            line-height: 28px;
        }

        ul {
            display: flex;
            flex-direction: column;
            gap: 8px;

            li {
                display: flex;
                align-items: baseline;
                gap: 16px;

                .img-wrap {
                    width: 16px;
                    height: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                p {
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 24px;
                }
            }
        }
    }
    
`
export default ContactWrap